import { Component, h } from 'preact'
import Card from '../cards/index'
import Phrase from '../../libs/translationsUtils/phrase'
import { ParentCategory, Category } from '../community-category/index.sync'

interface Props {
  selectedTemplate: number
  displayOnlyParent: boolean
  title: string
  categories: ParentCategory[]
}

class KnowledgeBase extends Component<Props> {
  constructor (props: Props) {
    super(props)
    this.getMetadata = this.getMetadata.bind(this)
  }

  templates = ['big-card', 'small-card']

  getMetadata (categories: Category[]) {
    let totalTopicCount = 0

    categories.forEach(category => {
      totalTopicCount += category.topicCount
    })

    return (
      <ul className='list--dot-seperated knowledge-base__card-metadata'>
        <li className='qa-forum-overview-category-counter'>
          {categories.length} <Phrase
            m='Forum' p='knowledgebase.category'
            count={{ n: categories.length.toString() }}
                              />
        </li>
        <li className='qa-forum-overview-post-counter'>
          <Phrase
            m='Common' p='knowledge.base.articles'
            count={{ n: totalTopicCount.toString() }}
          />
        </li>
      </ul>
    )
  }

  render ({ title, selectedTemplate, categories, displayOnlyParent }: Props) {
    if (!categories.length) {
      return null
    }

    return (
      <section
        className='full-width Template-brand-featured homepage-widget-wrapper knowledge-base-container qa-knowledge-base-container custom-knowledge-base'
      >
        <div className='sitewidth'>
          <div className='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <div className='knowledge-base-category-list'>
              {
                displayOnlyParent
                  ? (
                      categories.map((category, idx) => (
                        <Card
                          key={category.id}
                          customClass={`knowledge-base__card knowledge-base__card-${this.templates[selectedTemplate]}`}
                          idx={idx}
                          title={category.title}
                          metadata={this.getMetadata(category.subforums)}
                          imageSrc={category.thumbnailUrl}
                          navigation={{
                            url: category.url
                          }}
                        />
                      ))
                    )
                  : (
                    <div className='knowledge-base_parent-child-component-wrapper'>
                      {
                        categories.map((category) => (
                          <section className='knowledge-base_parent-child-component' key={category.id}>
                            {
                              title
                                ? <div className='knowledge-base-category-list_parent-title'>{category.title}</div>
                                : <h3 className='widget__heading'>{category.title}</h3>
                            }
                            <div className='knowledge-base-category-list'>
                              {
                                category.subforums.map((subcategory, idx) => (
                                  <Card
                                    key={subcategory.id}
                                    customClass={`knowledge-base__card knowledge-base__card-${this.templates[selectedTemplate]} id-${subcategory.id}`}
                                    idx={idx}
                                    title={subcategory.title}
                                    metadata={(
                                      <div className='knowledge-base__card-metadata'>
                                        <p className='text--meta'>
                                          <Phrase
                                            m='Common' p='knowledge.base.articles'
                                            count={{ n: subcategory.topicCount.toString() }}
                                          /></p>
                                      </div>
                                    )}
                                    imageSrc={subcategory.thumbnailUrl}
                                    navigation={{
                                      url: subcategory.url
                                    }}
                                  />
                                ))
                              }
                            </div>
                          </section>
                        ))
                      }
                    </div>
                    )
              }
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default KnowledgeBase
